import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "url-search-params-polyfill";
import "promise-polyfill/src/polyfill";
import "whatwg-fetch";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./styles/index.sass";
import { IntlProvider } from "react-intl";
import { messagesFi } from "i18n/fi";

ReactDOM.render(
  <React.StrictMode>
    <IntlProvider messages={messagesFi} locale="fi" defaultLocale="fi">
      <App />
    </IntlProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
